var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.colorMsg,"timeout":"-1","bottom":_vm.alignX === 'bottom',"right":_vm.alignY === 'right',"left":_vm.alignY === 'left'},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.textError)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }